/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiFormRuleTypeFromJSON, ApiFormRuleTypeToJSON, } from './ApiFormRuleType';
export function ApiFormRuleInputFromJSON(json) {
    return ApiFormRuleInputFromJSONTyped(json, false);
}
export function ApiFormRuleInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'mapping': !exists(json, 'mapping') ? undefined : json['mapping'],
        'target': !exists(json, 'target') ? undefined : json['target'],
        'type': !exists(json, 'type') ? undefined : ApiFormRuleTypeFromJSON(json['type']),
    };
}
export function ApiFormRuleInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mapping': value.mapping,
        'target': value.target,
        'type': ApiFormRuleTypeToJSON(value.type),
    };
}
